import React, { useState } from "react";
import "./sellhouse.css";
import { useNavigate } from "react-router-dom";
import API from "../../../api";

function SellHouse() {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [city, setCity] = useState("");
const [state, setState] = useState("");

  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

 const handleSubmit = async () => {
  if (!localStorage.getItem("token")) {
    alert("Please login again");
    return;
  }

  if (!title || !city || !price) {
    alert("Title, city and price are required");
    return;
  }

  try {
    setLoading(true);

    const formData = new FormData();
    formData.append("title", title);
    formData.append("city", city);
    formData.append("state", state);
    formData.append("price", price);
    formData.append("description", description);

    if (imageFile) {
      formData.append("image", imageFile);
    }

    const res = await API.post("/house/sell", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

    if (res.data.success) {
      alert("House posted successfully");
      navigate("/home");
    } else {
      alert(res.data.message || "Failed to post house");
    }
  } catch (err) {
    console.error("SELL HOUSE ERROR:", err);
    alert("Server error. Please try again.");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="sell-page">
      <div className="sell-card">

        {/* Header actions */}
        <div className="sell-header-actions">
          <button
            className="sell-back-btn"
            onClick={() => navigate(-1)}
          >
            ← Back
          </button>

          <button
            className="sell-close-btn"
            onClick={() => navigate("/")}
          >
            ✕
          </button>
        </div>

        <h2 className="sell-title">Sell Your House</h2>
        <p className="sell-subtitle">
          Add accurate details to reach genuine buyers faster
        </p>

        <div className="form-group">
          <label>House Title</label>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="e.g. 3BHK Independent House"
          />
        </div>

       <div className="form-group">
  <label>City</label>
  <input
    value={city}
    onChange={(e) => setCity(e.target.value)}
    placeholder="City"
  />
</div>

<div className="form-group">
  <label>State</label>
  <input
    value={state}
    onChange={(e) => setState(e.target.value)}
    placeholder="State"
  />
</div>


        <div className="form-group">
          <label>Price</label>
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            placeholder="₹ Expected price"
          />
        </div>

        {/* 🔑 FILE INPUT */}
        <div className="form-group">
          <label>House Image</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => {
              const file = e.target.files[0];
              setImageFile(file);
              if (file) {
                setPreview(URL.createObjectURL(file));
              }
            }}
          />
        </div>

        {/* IMAGE PREVIEW */}
        {preview && (
          <img
            src={preview}
            alt="Preview"
            className="sell-image-preview"
          />
        )}

        <div className="form-group">
          <label>Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Describe your house, amenities, age, nearby facilities..."
          />
        </div>

        <button
          className="post-btn"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Posting..." : "Post House"}
        </button>
      </div>
    </div>
  );
}

export default SellHouse;
